import { useState } from "react";

import {
  makeGetApiCall,
  makePostApiCall,
  makePutApiCall,
} from "../../../shared/makeApiCall";
import InventoryTypeDetailsForm from "../../../components/forms/setup/inventoryTypes/InventoryTypeDetailsForm";
import { BannerNotificationType } from "../../../components/SimpleNotification";
import DeleteConfirmationForm from "../../../components/forms/DeleteConfirmationForm";
import { updateObjectInArray } from "../../../shared/utility";

export function InventoryTypesViewModel(logout) {
  const [loading, setLoading] = useState(false);
  const [inventoryTypes, setInventoryTypes] = useState({
    data: [],
  });
  const [showSimpleNotification, setShowSimpleNotification] = useState({
    show: false,
    message: null,
    title: null,
    type: BannerNotificationType.Success,
  });
  const [slideOver, setSlideOver] = useState({
    childComponent: null,
    open: false,
  });
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });

  const getInventoryTypes = async function (search, page) {
    setLoading(true);

    let callResult = await makePostApiCall(
      `inventoryTypes?page=${page}&search=${search}`
    );
    setLoading(false);
    if (callResult.success) {
      setInventoryTypes(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const createInventoryType = async function (values) {
    const payload = { ...values };
    let callResult = await makePostApiCall("inventoryTypes/create", payload);

    if (callResult.success) {
      setShowSimpleNotification({
        show: true,
        title: "Inventory type added",
        type: BannerNotificationType.Success,
      });
      setSlideOver({
        childComponent: null,
        open: false,
      });
      setTimeout(function () {
        getInventoryTypes("", 1);
      }, 1000);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const updateInventoryType = async function (values, index) {
    let callResult = await makePutApiCall(
      `inventoryTypes/${values.id}`,
      values
    );

    if (callResult.success) {
      setShowSimpleNotification({
        show: true,
        title: "Inventory type updated",
        type: BannerNotificationType.Success,
      });
      setSlideOver({
        childComponent: null,
        open: false,
      });

      const currentItems = [...inventoryTypes.data];
      var payload = {
        index: index,
        item: callResult.data.item,
      };
      const newItems = updateObjectInArray(currentItems, payload);
      setInventoryTypes({ ...inventoryTypes, data: newItems });
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const openAddInventoryTypeSlideOver = (isEdit, inventoryType, index) => {
    setSlideOver({
      childComponent: (
        <InventoryTypeDetailsForm
          inventoryType={inventoryType}
          isEdit={isEdit}
          setOpen={setSlideOver}
          actionCall={(payload) =>
            isEdit
              ? updateInventoryType(payload, index)
              : createInventoryType(payload)
          }
          title={
            isEdit ? `Update ${inventoryType.name}` : "Add new inventory type"
          }
        />
      ),
      open: true,
    });
  };

  const deleteInventoryType = async function (id, index) {
    setLoading(true);

    let callResult = await makePostApiCall(`deleteInventoryType/${id}`);
    setLoading(false);
    if (callResult.success) {
      setEmptyModelOpen({
        open: false,
        childComponent: null,
      });

      const newItems = inventoryTypes.data.filter((item) => item.id !== id);
      setInventoryTypes({ ...inventoryTypes, data: newItems });

      setShowSimpleNotification({
        show: true,
        title: callResult.data.message,
        type: BannerNotificationType.Success,
      });
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const askDeleteInventoryType = function (inventoryType, index) {
    setEmptyModelOpen({
      childComponent: (
        <DeleteConfirmationForm
          buttonMessage="Delete"
          confirmAction={() => deleteInventoryType(inventoryType.id, index)}
          message={`Are you sure you want to delete  ${inventoryType.name}?`}
          setOpen={setEmptyModelOpen}
          hideReason={true}
        />
      ),
      open: true,
    });
  };

  return {
    openAddInventoryTypeSlideOver,
    getInventoryTypes,
    loading,
    inventoryTypes,
    setSlideOver,
    slideOver,
    setShowSimpleNotification,
    showSimpleNotification,
    setEmptyModelOpen,
    emptyModal,
    askDeleteInventoryType,
  };
}
